<script lang="ts">
export default {
    name: "OffersAnimationSection",
    props: {
        offersAnimation: {
            type: Object,
            default: undefined
        }
    },
    computed: {
        showOffersAnimationSection() {
            return this.offersAnimation
                && this.offersAnimation.selectionsTileList
                && this.offersAnimation.selectionsTileList.length > 0;
        }
    }
}
</script>

<template>
    <section
        v-if="showOffersAnimationSection"
        class="container-fluid pt-1 pt-md-2"
    >
        <div class="row">
            <div class="col-12">
                <h2>{{ offersAnimation.title }}</h2>
            </div>
            <ul class="row list-unstyled" :aria-label="'Liste de '+ offersAnimation.selectionsTileList.length + ' forfaits mobiles'">
                <li
                    v-for="(selectionTile, index) in offersAnimation.selectionsTileList"
                    :key="index"
                    class="col-12 col-lg-6 pb-1 pb-lg-2"
                >
                    <div class="bg-dark h-100">
                        <template v-if="selectionTile.link">
                            <a
                                class="ob1-link no-decoration"
                                target="_blank"
                                :href="selectionTile.link"
                                :data-oevent-category="selectionTile.tms.category"
                                :data-oevent-action="selectionTile.tms.action"
                                :data-oevent-label="selectionTile.tms.label"
                            >
                                <div class="h-100 d-flex align-items-center">
                                    <img
                                        loading="lazy"
                                        :src="selectionTile.img.src"
                                        :alt="selectionTile.img.alt"
                                        class="img-avantages"
                                        aria-hidden="true"
                                    >
                                    <div class="p-1 text-white">
                                        <p class="lead fw-bold py-0 mb-0" v-msh-html="selectionTile.desc" />
                                    </div>
                                </div>
                            </a>
                        </template>
                        <template v-else>
                            <div class="h-100 d-flex align-items-center">
                                <img
                                    loading="lazy"
                                    :src="selectionTile.img.src"
                                    :alt="selectionTile.img.alt"
                                    class="img-avantages"
                                    aria-hidden="true"
                                >
                                <div class="p-1 text-white">
                                    <p class="lead fw-bold py-0 mb-0" v-msh-html="selectionTile.desc" />
                                </div>
                            </div>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<style scoped lang="scss">

.img-avantages {
    height: 105px;
    @media (min-width: 768px) {
        height: 130px;
    }
}

</style>
